import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PopoverService } from '@fcom/ui-components/components/popover/service/popover.service';
import { AppState } from '@fcom/core/interfaces/app-state.interface';
import { LoginStatus, LoginStep } from '@fcom/core-api/login/interfaces/login.interface';
import * as LoginActions from '@fcom/core/actions/login.actions';
import { ConfigService } from '@fcom/core/services/config/config.service';
import { getCurrentBreakPoint } from '@fcom/common/utils/layout.utils';
import { loginIsOpen, loginStatus } from '@fcom/core/selectors/login.selector';

import { LoginWidgetComponent, LoginWidgetContext } from '../login-widget/login-widget.component';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'fin-login-dialog',
  templateUrl: './login-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginDialogComponent implements OnInit {
  private loginService = inject(LoginService);
  private store$ = inject<Store<AppState>>(Store);
  private configService = inject(ConfigService);
  private popoverService = inject(PopoverService);
  private readonly loginStatusSignal = toSignal(this.store$.pipe(loginStatus()), {
    initialValue: LoginStatus.INITIAL,
  });
  private readonly isLoggedIn = computed(() => this.loginStatusSignal() === LoginStatus.LOGGED_IN);

  @ViewChild('loginWidget', { static: true }) loginWidget: LoginWidgetComponent;

  @Input()
  context: LoginWidgetContext;

  loginOpen$: Observable<boolean>;
  mobileOrTablet: boolean;

  toggleLogin(event: Event): void {
    this.popoverService.close();
    const currentBreakpoint = getCurrentBreakPoint();

    event.stopPropagation();

    this.mobileOrTablet = ['mobile', 'tablet'].includes(currentBreakpoint);
    if (this.isLoggedIn() || this.mobileOrTablet) {
      this.loginWidget.open();
    } else if (this.configService.cfg.enableLoginDialog) {
      this.store$.dispatch(LoginActions.setLoginPhaseStep({ step: LoginStep.CREDENTIALS }));
    } else {
      this.loginService.redirectToLogin();
    }
  }

  ngOnInit(): void {
    this.loginOpen$ = this.store$.pipe(loginIsOpen());
  }
}
